import fetch from '@/utils/fetch'

export function payConfirm (data, moduleType, from) {
  data.uniteOrderNo = data.orderNo
  let url = '/ows/order/unite/payment'
  if (moduleType === 'HOTEL') {
    url = '/website/hotel/order/payment'
  } else if (moduleType === 'FOOD') {
    url = '/website/food/order/payment'
  } else if (moduleType === 'PACKAGES') {
    url = '/website/packages/order/payment'
  } else if (moduleType === 'RETAIL') {
    if (from === 'cart') {
      url = '/website/cart/order/payment'
      data.uniteOrderNos = data.orderNo
      data.isNativeWechatPay = false
      delete data.uniteOrderNo
      delete data.orderNo
    } else {
      url = `/website/retail/order/${data.orderNo}/payment`
    }
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}

export function cancelOrder (data, moduleType) {
  let url = '/ows/trip/order/cancel'
  if (moduleType === 'HOTEL') {
    url = '/website/hotel/order/cancel'
  } else if (moduleType === 'FOOD') {
    url = '/website/food/order/cancel'
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}

export function orderInfo (orderNo, moduleType, from) {
  let url = '/ows/order/unite/detail/' + orderNo
  let data = {}
  if (moduleType === 'HOTEL') {
    url = '/website/hotel/order/detail/' + orderNo
  } else if (moduleType === 'FOOD') {
    url = '/website/food/order/order-detail/' + orderNo
  } else if (moduleType === 'PACKAGES') {
    url = '/website/packages/order/detail/' + orderNo
  } else if (moduleType === 'RETAIL') {
    url = `/website/retail/order/${orderNo}/info`
    if (from === 'cart') {
      url = `website/cart/order/info`
      data = {
        uniteOrderNos: orderNo
      }
    }
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}

// 联合订单信息查询
export function uniteOrderInfo (orderNo) {
  return fetch({
    url: 'website/cart/order/info',
    method: 'post',
    data: {
      uniteOrderNos: orderNo
    }
  })
}

export function getSysTime () {
  return fetch({
    url: '/system/environment/',
    method: 'post'
  })
}
